import { createSlice } from "@reduxjs/toolkit";

interface DatabaseState {
  filtersActive: boolean;
  bulkCSVModal: boolean
  restoreContactModal: boolean
}

const initialState: DatabaseState = {
  filtersActive: false,
  bulkCSVModal: false,
  restoreContactModal: false
};

const databaseSlice = createSlice({
  name: "database/slice",
  initialState,
  reducers: {
    setFiltersActive: (state, action) => {
      state.filtersActive = action.payload;
    },
    setBulkCSVModal: (state, action) => {
      state.bulkCSVModal = action.payload;
    },
    setRestoreContactModal: (state, action) => {
      state.restoreContactModal = action.payload
    }
  },
});

export const { setFiltersActive, setBulkCSVModal, setRestoreContactModal } =
  databaseSlice.actions;

export default databaseSlice.reducer;
